import { Box } from '@src/atoms/Box';
import { ImageRenderer } from '@src/atoms/ImageRenderer';
import { Text } from '@src/atoms/Text';
import React, { FC } from 'react';

import styled from './BundleBody.module.scss';
import { MainBonus } from '../_MainBonus/MainBonus';
import { ProductLogos } from '../_ProductLogos/ProductLogos';
import { TooltipNew } from '@src/atoms/TooltipNew';
import { IconV2 } from '@src/atoms/IconV2';
import { TColor } from '@src/models/common';
import { IProduct } from '@src/models/entities';

interface IBundleBodyProps {
  title: string;
  description: string;
  budget: string;
  discount: string;
  bundleIcon: string;
  bundleColor?:
    | TColor
    | 'basicOverlay'
    | 'basicGreyInput'
    | 'basicGreyInputColor'
    | 'basicGreyInputPlaceholder'
    | 'basicGreydarkInput'
    | 'basicGreydarkInputColor'
    | 'basicGreydarkInputPlaceholder';
  mainBonus?: string;
  bonusesCount?: number;
  isMulti?: boolean;
  arrowBonus?: boolean;
  includedProductsLogos?: IProduct[];
  isWide?: boolean;
}

export const BundleBody: FC<IBundleBodyProps> = ({
  title,
  description,
  budget,
  discount,
  bundleIcon,
  bundleColor,
  mainBonus,
  bonusesCount,
  isMulti,
  arrowBonus,
  includedProductsLogos,
  isWide,
}) => {
  return (
    <>
      <Box fullWidth bgColor={bundleColor} className={styled.coloredPart} marginBottom={16} />
      <Box column gap={16}>
        {!isWide && (
          <Box justifyContent={'spaceBetween'}>
            <Box className={styled.logoContainer}>
              <ImageRenderer url={bundleIcon} width={64} height={64} />
            </Box>
            <ProductLogos products={includedProductsLogos} />
          </Box>
        )}
        <Box justifyContent={'spaceBetween'}>
          <Box column gap={2} style={!isWide ? { height: 90 } : {}}>
            <Text id="bundleTitle" weight={'bold'} size={'secondary'}>
              {title}
            </Text>
            <Text id="bundleDescription" size={'caption'} color={'basicGreySemiDark'}>
              {description}
            </Text>
          </Box>
          {isWide && <ProductLogos products={includedProductsLogos} />}
        </Box>
        <Box column={!isWide} gap={isWide ? 24 : 8} style={!isWide ? { height: 96 } : {}}>
          <Box column gap={2}>
            <Text id="budgetSectionTitle" size={'caption'} color={'basicGreySemiDark'}>
              Бюджет до НДС
            </Text>
            <Box gap={2} alignItems={'center'}>
              <Text id="budgetText" size={isWide ? 'h4' : 'primary'} weight={'bold'} nowrap>
                {budget} ₽
              </Text>
              {isMulti && (
                <TooltipNew content={`Бюджет по каждому продукту должен быть ${budget} ₽`} maxWidth={168}>
                  <Box>
                    <IconV2 name={'outline-help'} size={'sm'} />
                  </Box>
                </TooltipNew>
              )}
            </Box>
          </Box>
          <Box column>
            <Text id="discountSectionTitle" size={'caption'} color={'basicGreySemiDark'}>
              Скидка
            </Text>
            <Text id="discountText" size={'primary'} weight={'bold'}>
              <Text
                id={'discountSpan'}
                size={isWide ? 'h4' : 'primary'}
                weight={'bold'}
                tag={'span'}
                color={'statusSuccessBright'}
              >
                {`-${discount}% `}
              </Text>
              на размещение
            </Text>
            {arrowBonus && <MainBonus mainBonus={mainBonus} bonusesCount={bonusesCount} isMulti={isMulti} isArrow />}
          </Box>
        </Box>
      </Box>
    </>
  );
};
